import { createFileRoute } from "@tanstack/react-router";
import { Schema } from "effect";

import { UserManagement } from "@/admin/components/user-management";
import { AppLayout } from "@/shared/layout";

const SearchSchema = Schema.Struct({
  include: Schema.optional(
    Schema.mutable(Schema.Array(Schema.String))
  ),
  exclude: Schema.optional(
    Schema.mutable(Schema.Array(Schema.String))
  ),
});

export const Route = createFileRoute("/app/admin/users")({
  validateSearch: Schema.toStandardSchemaV1(SearchSchema),
  loader: async ({ context }) => {
    await context.queryClient
      .query(context.trpc.admin.getUsers.queryOptions({}))
      .catch(() => undefined);
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AppLayout title="User Management">
      <UserManagement />
    </AppLayout>
  );
}
